import { useEffect, useMemo, useState } from "react";
import { Flex, Table } from "antd";
import { Link } from "react-router-dom";
import {
  BrandAvatar,
  CopyButton,
  StatusLabel,
  Button,
  Icon,
  ActionButton,
} from "ui";
import { toDate, toDateTime } from "core/utils/date-time";
import { getImageSrc } from "core/utils/json-utils";
import { useDeleteArticle, useGetArticles } from "pages/articles/api";
import { article } from "pages/articles/type";
import { ARTICLES_TABLE_COLUMN } from "pages/articles/constant";
import { useArticleManagementStore } from "pages/articles/store";

const ArticlesTable = () => {
  const { filter, setHeaderInfo, page, setPage } = useArticleManagementStore((state) => state);

  const { data, isPending } = useGetArticles({
    page: page,
    pageSize: 10,
    inputParams: {
      filters: filter || [],
      sort: {
        propertyName: "id",
        ascending: false,
      },
    },
  });
  const { mutate: deleteArticle } = useDeleteArticle();

  useEffect(() => {
    if (data?.data?.totals) {
      setHeaderInfo?.({ totals: data.data.totals });
    }
  }, [data]);

  const dataSource = useMemo(() => {
    return (
      (data?.data?.data ?? []).map((item: article) => {
        return {
          key: item.id,
          image: (
            <BrandAvatar
              img={getImageSrc(item.image?.url, true)}
              label={item.title}
            />
          ),
          title: (
            <Flex vertical align="start" gap="5px">
              <strong className="color-primary">{item?.title ?? "-"}</strong>
              <label className="color-stroke">
                تاریخ ثبت: {toDateTime(item?.createdAt)}
              </label>
            </Flex>
          ),
          date: (
            <Flex vertical gap="5px">
              <strong className="color-stroke">
                از تاریخ: {toDate(item?.from)}
              </strong>
              <strong className="color-stroke">
                تا تاریخ: {toDate(item?.to)}
              </strong>
            </Flex>
          ),
          status: (
            <Flex align="center" justify="center">
              <StatusLabel
                status={Number(item.state) === 1}
                customLabel={item.stateStr}
              />
            </Flex>
          ),
          link: (
            <Flex justify="center">
              <CopyButton
                value={
                  item?.seo?.url
                    ? `${process.env.REACT_APP_PUBLISH_WEBSITE_BASE_URL}/${item?.seo?.url}`
                    : undefined
                }
              />
            </Flex>
          ),
          action: (
            <Flex gap={10} align="center">
              <Link to={`/articles/${item.id}/article_sections`}>
                <Button type="primary" size="middle">
                  <Icon type="sr-plus" />
                  <span>ویرایش جزئیات </span>
                </Button>
              </Link>
              <ActionButton
                type="remove"
                onClick={() => deleteArticle(item.id ?? 0)}
              />
            </Flex>
          ),
        };
      }) || []
    );
  }, [data]);

  return (
    <Table
      locale={{ emptyText: "هیچ داده ای وجود ندارد" }}
      columns={ARTICLES_TABLE_COLUMN}
      dataSource={dataSource}
      loading={isPending}
      pagination={{
        current: page,
        showSizeChanger: false,
        total: data?.data?.totals ?? 0,
        onChange: (page) => {
          setPage(page);
        },
      }}
    />
  );
};

export default ArticlesTable;
